import {
  CheckCircle,
  ContentCopy,
  CopyAll,
  Edit,
  EditNote,
  ErrorOutline,
  KeyboardArrowDown,
  RunCircleRounded,
} from "@mui/icons-material";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  Button,
  Divider,
  CircularProgress,
  InputBase,
  Alert,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import DeleteRouteModal from "../modals/DeleteRouteModal";
import planData from '../plans.json';
import TimePicker from "react-time-picker";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { useWindowSize } from 'react-use'
import Confetti from 'react-confetti'

import { jwtDecode } from "jwt-decode";
import AllSetUpModal from "../modals/AllSetUpModal";
import ConfirmPageReload from "../modals/ConfirmPageReload";
import { formatPhoneNumber } from "../utils/formatnumber";
import ChangeOrgModal from "../modals/ChangeOrgModal";
import ChangeOrgModalNew from "../modals/ChangeOrgModalNew";
import posthog from "posthog-js";
import decryptApi from "../utils/decryptApi";
const CallRoute = ({ navigate }) => {
  console.log(JSON.parse(localStorage.getItem("organization")));
  const { route_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [error_msg, setErrormsg] = useState(null);

  const [prev_config_phone, setPrevConfigPhone] = useState(JSON.parse(localStorage.getItem("organization"))
  .twilio_integration.M.primary_phone.S)


  const [planDetails, setPlanDetails] = useState(null);
  const check_subscription = async () => {
    try {
      setLoader(true)
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
          sub_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_sub.S,
        }
      );

      console.log(sub.data)

      console.log(planData[sub.data?.planDetails[0].plan_id])
      setPlanDetails(planData[sub.data?.planDetails[0].plan_id])
      return;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };
  const [routes, setRoutes] = useState([])


  const getRoutes = async () => {
    try {
      let routes = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-routes",
        { org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      );

      console.log({ routes });

      setRoutes(routes.data.routes);
      setRoute({ ...route, route_name: `Route ${routes.data.routes ? routes.data.routes.length + 1 : 1}` })
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
      }
      setLoader(false);
    }
  };

  useEffect(() => {
    getRoutes()
    check_subscription()
  }, [])





  const [route, setRoute] = useState({
    route_name: `loading...`,
    configured_phone: JSON.parse(localStorage.getItem("organization"))
      .twilio_integration.M.primary_phone.S,
    organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    early_time: "12:00 AM",
    late_time: "11:59 PM",
    primary_action: "forward",
    recording_id: null,
    primary_number: null,
    off_hours_number: null,
    primary_channel: null,
    off_hours_action: "forward",
    off_hours_recording: null,
    off_hours_number: null,
    off_hours_channel: null,
    active_friday: true,
    active_monday: true,
    active_saturday: true,
    active_sunday: true,
    active_thursday: true,
    active_tuesday: true,
    active_wednesday: true,
  });




  const [change_org, setChangeOrg] = useState(false)





  const [calls, setCalls] = useState(null);
  const [incomming_phonenumbers, setIncommingPhonenumbers] = useState(null);
  const [editName, setEditName] = useState(false);
  const [notification, setNotification] = useState({
    notification: 'none',

    notification_detail: null
  })

  const [off_hours_notification, setOffHoursNotification] = useState({
    notification: 'none',

    notification_detail: null
  });


  useEffect(() => { }, [notification.notification_detail]);

  useEffect(() => { }, [off_hours_notification.notification_detail !== null]);

  const getRoute = async () => {
    try {
      let route = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-route",
        { route_id }
      );

      console.log(route);

      getIncomingPhoneNumbers();
      setLoader(false);

      // let calls = await axios.post(
      //   process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
      //   { route_id, organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      // );

      // const now = Date.now();
      // const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

      // let rc = calls.data.calls.filter(call => {
      //   const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
      //   return timestamp >= thirtyDaysAgo && timestamp <= now;
      // });

      // console.log('recent_calls', rc)

      // setCalls(rc);

      let r = route?.data.route;

      console.log({ r });

      setRoute({
        route_id: r.routeId,
        route_name: r.name,
        configured_phone: r.configured_phone,
        organization_id: r.org_id,
        early_time: r.earlyTime,
        late_time: r.lateTime,
        primary_action: r.primaryAction,
        recording_id: r.primaryRecording,
        primary_number: r.primaryNumber,
        off_hours_number: r.offHoursNumber,
        primary_channel: r.primaryChannel,
        off_hours_action: r.offHoursAction,
        off_hours_recording: r.offHoursRecording,
        off_hours_number: r.offHoursNumber,
        off_hours_channel: r.offHoursChannel,
        active_friday: r.calendar.fri.BOOL,
        active_monday: r.calendar.mon.BOOL,
        active_saturday: r.calendar.sat.BOOL,
        active_sunday: r.calendar.sun.BOOL,
        active_thursday: r.calendar.thur.BOOL,
        active_tuesday: r.calendar.tue.BOOL,
        active_wednesday: r.calendar.wed.BOOL,
      });


      let channels = (JSON.parse(localStorage.getItem("organization"))).channels?.L

      console.log(channels)



      setNotification({
        notification:
          channels.filter(
            (ch) => ch.M.ch_id.S === r.primaryChannel
          )[0]?.M.type.S || "none",
        notification_detail: channels.filter((ch) => ch.M.ch_id.S === r.primaryChannel)[0]?.M
          .value.S || '',
      });


      setOffHoursNotification({
        notification:
          channels.filter(
            (ch) => ch.M.ch_id.S === r.offHoursChannel
          )[0]?.M.type.S || "none",
        notification_detail: channels.filter((ch) => ch.M.ch_id.S === r.offHoursChannel)[0]?.M
          .value.S || '',
      });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };



  async function getIncomingPhoneNumbers(apiSecret) {
    setLoader(true);
    setErrormsg(null);
    let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
      .M;
    console.log(t);
    await axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "twilio/get-incoming-phone-numbers",

        {
          organization_id: JSON.parse(localStorage.getItem("organization"))
            .orgId.S,
          account_sid: t.account_sid.S,
          api_key: (t.api_key.S),
          transcription_enabled: t.transcription_enabled.BOOL,
          test_account: t.test_account.BOOL,
          auto_configuration: t.auto_configuration.BOOL,
          primary_phone: t.primary_phone.S,
        }
      )
      .then((res) => {
        let data = res.data
        if (res.data.length < 1) {
          setErrormsg(
            "please add an incoming phone number in your twilio account"
          );
          setLoader(false);
        } else {
          if (t.test_account.BOOL) {
            console.log('get_incoming_phone_numbers', data)
            setIncommingPhonenumbers(data.filter(item => item.phoneNumber === t.primary_phone.S))
          } else {
            setIncommingPhonenumbers(res.data);
          }
          console.log(res.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data) {
          console.error("Response data:", err.response.data);
          setErrormsg(err.response.data.message);
        }
        setLoader(false);
      });
  }
  async function updateRoute() {
    setLoader(true);
    console.log({ route });
    let check = await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`, {
      userId: JSON.parse(localStorage.getItem('user')).userId.S
    });

    if (check.status === 200) {
      const user___ = check.data.user;


      if (user___.relatedOrgs.L?.find((e) => e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)) {
        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/update-route",
            route
          );


          let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
            .M;

          if (t.auto_configuration.BOOL) {
            let update_voice = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
              {
                account_sid: t.account_sid.S,
                api_key: t.api_key.S,
                phone_number: route.configured_phone,
                webhook_url: `https://incoming.twilanswer.com/${route_id}`
              }
            );

            if(route.configured_phone != prev_config_phone){
             let update_voice_for_old_phone =  await axios.post(
                process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
                {
                  account_sid: t.account_sid.S,
                  api_key: t.api_key.S,
                  phone_number: prev_config_phone,
                  webhook_url: `https://incoming.twilanswer.com/default`
                }
              );
              console.log({ update_voice, update_voice_for_old_phone })
            }

          }
          setLoader(false);
          getRoute();
          setSuccessMsg("Route Settings Successfully Updated");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => {
            setSuccessMsg(null)
          }, 4000);
        } catch (error) {
          console.log(error);
          if (error.response && error.response.data) {
            console.error("Response data:", error.response.data);
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }

      } else {
        window.location.reload()
      }

    }
  }

  async function deleteRoute() {
    setLoader(true);
    setOpenDeleteRouteModal(false)
    console.log({ route });

    let check = await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`, {
      userId: JSON.parse(localStorage.getItem('user')).userId.S
    });

    if (check.status === 200) {
      const user___ = check.data.user;


      if (user___.relatedOrgs.L?.find((e) => e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)) {
        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/delete-route",
            { route_id }
          );

          let organization = await axios
            .post(
              process.env.REACT_APP_BACKEND_URL + "delete-route",
              {
                organization_id: JSON.parse(localStorage.getItem("organization"))
                  .orgId.S,
                route_id,
              }
            )

          localStorage.setItem('organization', JSON.stringify(organization.data.organization))



          let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
            .M;

          if (t.auto_configuration.BOOL) {
            let update_voice = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
              {
                account_sid: t.account_sid.S,
                api_key: t.api_key.S,
                phone_number: route.configured_phone,
                webhook_url: `https://incoming.twilanswer.com/default`
              }
            );

            console.log({ update_voice })
          }
          setLoader(false);
          setSuccessMsg("Route Successfully Deleted. Remember to Update Twilio Settings. Redirecting you to your call routes");
          setTimeout(() => {
            setSuccessMsg(null)
            navigate("/dashboard/call-routings/")
          }, 4000);
        } catch (error) {
          console.log(error);
          if (error.response && error.response.data) {
            console.error("Response data:", error.response.data);
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }

      } else {
        window.location.reload()
      }

    }
  }

  async function createRoute() {
    setLoader(true);

    console.log({ route });
    let check = await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`, {
      userId: JSON.parse(localStorage.getItem('user')).userId.S
    });

    if (check.status === 200) {
      const user___ = check.data.user;


      if (user___.relatedOrgs.L?.find((e) => e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)) {

        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/create-route",
            route
          );

          let organization = await axios
            .post(
              process.env.REACT_APP_BACKEND_URL + "add-route",
              {
                organization_id: JSON.parse(localStorage.getItem("organization"))
                  .orgId.S,
                route_id: route_data.data.route.routeId.S,
              }
            )

          localStorage.setItem('organization', JSON.stringify(organization.data.organization))


          let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
            .M;

          if (t.auto_configuration.BOOL) {
            let update_voice = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
              {
                account_sid: t.account_sid.S,
                api_key: await t.api_key.S,
                phone_number: route.configured_phone,
                webhook_url: `https://incoming.twilanswer.com/${route_data.data.route.routeId.S}`
              }
            );

            console.log({ update_voice })
          }
          setLoader(false);

          setSuccessMsg("Route saved successfully. Redirecting you now.");
          window.scrollTo({ top: 0, behavior: "smooth" });
          //post hog track event for create route
          posthog.capture('Created a route', {
            email: JSON.parse(localStorage.getItem('user')).email.S,
            userId: JSON.parse(localStorage.getItem('user')).userId.S,
          });

          setTimeout(() => {
            setSuccessMsg(null)
            navigate("/dashboard/call-route/" + route_data.data.route.routeId.S);
          }, 2000);
        } catch (error) {
          console.log(error);
          if (error.response && error.response.data) {
            console.error("Response data:", error.response.data);
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload()
      }

    }
  }

  useEffect(() => {
    if (route_id) {
      // getRoute();
    } else {
      getIncomingPhoneNumbers();
      setLoader(false);
    }
  }, []);

  useEffect(() => {

    // console.log(route.organization_id)
    // if(route.organization_id !== JSON.parse(localStorage.getItem("organization")).orgId.S){
    //   setChangeOrg(true)
    // }

    if (route_id && routes?.length >= 1) {
      console.log('routes', routes.find((e) => e.routeId.S === route_id))
      if (routes.find((e) => e.routeId.S === route_id)) {
        getRoute();
        setChangeOrg(false)

      } else {
        setChangeOrg(true)
      }

    }
    else if(!route_id){
      setChangeOrg(false)
    }else{
      setChangeOrg(true)
    }
  }, [routes])

  const [copied, setCopied] = useState(false)
  async function copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      console.log('Text copied to clipboard:', text);
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  }
  const [openDeleteRouteModal, setOpenDeleteRouteModal] = useState(false)
  const [successMsg, setSuccessMsg] = useState(null)
  const handleTimeChange = (e) => {
    const value = e.target.value; let [hours, minutes] = value.split(":"); hours = parseInt(hours); let period = "AM"; if (hours >= 12) { period = "PM"; if (hours > 12) hours -= 12; } if (hours === 0) hours = 12; const formattedTime = `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
    alert(formattedTime)
    setRoute({ ...route, early_time: formattedTime });
  };

  function convertTo24Hour(time) {
    let [hours, minutes] = time.split(/[: ]/);
    const period = time.slice(-2);

    hours = parseInt(hours);
    if (period === "AM" && hours === 12) hours = 0;
    if (period === "PM" && hours < 12) hours += 12;

    const formattedHours = String(hours).padStart(2, "0");
    return `${formattedHours}:${minutes}`;
  }

  function convertTo12Hour(time) {
    let [hours, minutes] = time.split(":"); hours = parseInt(hours); const period = hours >= 12 ? "PM" : "AM"; hours = hours % 12 || 12;
    // Convert "0" or "00" to "12"
    const formattedTime = `${String(hours).padStart(2, "0")}:${minutes} ${period}`; return formattedTime;
  }
  const { width, height } = useWindowSize()


  const [confetti, setConfetti] = useState(localStorage.getItem('show_confetti'))
  let confettiPieces = 1000; // Initial number of confetti pieces
  console.log("Confetti starts");

  // useEffect(()=>{
  //   setTimeout(() => {
  //     localStorage.removeItem('show_confetti')
  //     setConfetti(false)
  //   }, 5000);
  // })
  useEffect(() => {

    if (confetti) {
      const interval = setInterval(() => {
        if (confettiPieces > 0) {
          confettiPieces -= 10; // Reduce by 10 pieces
          console.log("Confetti pieces:", confettiPieces);
        }
      }, 1000);// Interval runs every 100 milliseconds

      setTimeout(() => {
        clearInterval(interval); // Stop the interval after 5 seconds
        console.log("Confetti stops");
        setConfetti(false)
        localStorage.removeItem('show_confetti')
      }, 10000);
    }

  }, [confetti]);
  const [openAllSetUpModal, setOpenAllSetupModal] = useState(false);
  const cameFromRegister = localStorage.getItem("cameFromRegister") === "true";

  useEffect(() => {
    if (cameFromRegister) {
      setOpenAllSetupModal(true);
      localStorage.removeItem("cameFromRegister");
    }
  }, [cameFromRegister]);



  const [openConfirmModal, setOpenConfirmModal] = useState(false)
  const [page, setPage] = useState(null)



  const handleNavigation = (to) => {

    window.location.assign(to);
  };


  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
  const [orgs, setOrgs] = useState()

  const getAllOrgs = async () => {
    setLoader(true)
    let orgs = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "get-organizations",
      {
        userId: JSON.parse(localStorage.getItem('user')).userId.S
      }
    );
    console.log('orgs', orgs)
    setOrgs(orgs.data)
    setLoader(false)
  }
  useEffect(() => {
    getAllOrgs()
    const handleBeforeUnload = (event) => {
      // Prevent the default browser prompt
      event.preventDefault();
      // Modern browsers may still show a generic warning; this avoids it
      event.returnValue = "";
    };

    // Add event listener for beforeunload
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Cleanup the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const changeOrganization = async (org_id) => {
    try {
      let org = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "get-organization",
        { orgId: org_id }
      );
      localStorage.setItem(
        "organization",
        JSON.stringify(org.data.organization)
      );

      window.location.reload()
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };



  return (
    <>
      {/* <ChangeOrgModalNew open={change_org} setOpen={setChangeOrg}  /> */}
      {confetti && (
        <Confetti
          width={width - 30}
          height={height}
          numberOfPieces={confettiPieces}
          gravity={0.1} // Controls how fast confetti falls
          recycle={false}
        />
      )}

      <ConfirmPageReload open={openConfirmModal} setOpen={setOpenConfirmModal} page={page} />
      <AllSetUpModal open={openAllSetUpModal} setOpen={setOpenAllSetupModal} />
      <div className="pt-7 px-4">

        <DeleteRouteModal open={openDeleteRouteModal} setOpen={setOpenDeleteRouteModal} num={route.configured_phone} deleteRoute={deleteRoute} />
        {error_msg && (
          <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
            <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
          </div>
        )}

        {successMsg && (
          <Alert color={'success'} sx={{ my: 2 }}  >
            <div className="text-[14px]">{successMsg}</div>
          </Alert>
        )}

        {/* {loader && (
        <div className="flex justify-center">
          <CircularProgress size={"3rem"} sx={{ color: "blue" }} />
        </div>
      )} */}

        {!change_org ? (
          <div>
            <div className="lg:flex items-center mb-4 lg:space-x-8 lg:space-y-0 space-y-3 relative">
              <div className="flex items-center lg:space-x-8 space-x-0 justify-between">
                {loader && (
                  <div className="flex justify-center">
                    <CircularProgress size={"1.0rem"} sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
                  </div>
                )}
                <div className="text-[17px] font-semibold ">
                  {editName ? (
                    <InputBase
                      value={route?.route_name}
                      onChange={(e) => {
                        setRoute({ ...route, route_name: e.target.value });
                      }}
                      sx={{
                        bgcolor: "white",
                        width: "100%",
                        px: 2,
                        py: "2px",
                        fontSize: "14px",
                      }}
                    />
                  ) : (
                    <>{route?.route_name}</>
                  )}
                </div>
                <div className="cursor-pointer">
                  {editName ? (
                    <div
                      className="cursor-pointer hover:underline hover:text-purple-500 text-[14px]"
                      onClick={() => {
                        setEditName(false);
                      }}
                    >
                      Save{" "}
                    </div>
                  ) : (
                    <EditNote
                      sx={{ color: "gray", width: "25px" }}
                      onClick={() => {
                        setEditName(true);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="bg-[#FAFAFB]  py-2 text-[12px] px-4 text-center font-semibold rounded-[15px] break-words" hidden={!route_id && true}>
                https://incoming.twilanswer.com/{route_id}{" "}
                {copied ? (
                  <CheckCircle
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(`https://incoming.twilanswer.com/${route_id}`)
                    }}
                    sx={{
                      color: "gray",
                      width: "20px",
                      position: "relative",
                      bottom: 2,
                    }}
                  />
                ) : (
                  <ContentCopy
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(`https://incoming.twilanswer.com/${route_id}`)
                    }}
                    sx={{
                      color: "gray",
                      width: "20px",
                      position: "relative",
                      bottom: 2,
                    }}
                  />
                )}
              </div>

              {/* {route_id && calls ? (
                <div
                  onClick={() => {
                    handleNavigation('/dashboard')
                  }}
                  className=" cursor-pointer bg-[rgba(96,91,255,0.1)] rounded-[15px] w-[190px] justify-center py-2 text-[#605BFF] flex items-center text-[12px] font-semibold">
                  <img src="/icons/phone_purple.png" className="w-[20px] mr-2" />{" "}
                  {calls?.length} Calls Last 30 Days
                </div>
              ): (
                <div className="flex justify-center">
                <CircularProgress size={"1rem"} sx={{ color: "rgb(96,91,255)",animationDuration:'0.7s' }} />
              </div>
              )} */}

              <div className=" lg:absolute  right-0" hidden={!route_id && true}>
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "#D11A2A",
                    color: "white",
                    py: "5px",
                    px: "20px",
                    borderRadius: "12px",
                    fontSize: { lg: "14px", xs: "12px" },

                  }}
                  disabled={loader}
                  onClick={() => {
                    setOpenDeleteRouteModal(true)
                  }}
                >
                  Delete Route
                </Button>
              </div>
            </div>

            <div className="bg-white py-5 rounded-[13px]   px-[50px] overflow-x-auto lg:overflow-x-auto">

              <div style={{ minWidth: '1000px' }} >
                <div className="pt-[20vh]   flex items-center">
                  <div className="border-[1px] rounded-[14px] px-2 py-2   w-fit   border-[#DADADA] space-y-3">
                    <div className="text-center lg:text-[14px] text-[12px]">
                      Incoming Call To
                    </div>
                    <div>
                      <Select
                        IconComponent={KeyboardArrowDown}

                        value={route?.configured_phone}
                        onChange={(e) => {
                          setRoute({
                            ...route,
                            configured_phone: e.target.value,
                          });
                        }}
                        className="mb-2 bg-[#FAFAFB]"
                        sx={{
                          fontSize: { lg: "14px", xs: "12px" },
                          padding: "4px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-select": {
                            padding: "4px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {incomming_phonenumbers &&
                          incomming_phonenumbers.map((item, index) => (
                            <MenuItem value={item.phoneNumber}>
                              {formatPhoneNumber(item.phoneNumber)}
                            </MenuItem>
                          ))}

                        {/* <MenuItem value={'393939393939393939'} >
                  9203939202020293939
                          </MenuItem> */}
                      </Select>
                    </div>

                    <div className="flex justify-center">
                      <img
                        src="/icons/incoming_call.png"
                        className="lg:w-[60px] w-[40px]"
                      />
                    </div>
                  </div>

                  <img src="/icons/arrow.png" className="w-[90px]" />
                  {planDetails?.timeRulesEnabled ? (
                    <div className="border-[1px] rounded-[14px] px-2 py-2 w-fit border-[#DADADA] space-y-3 h-[190px] pt-5 relative bottom-2">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Day/Time Rules
                      </div>
                      <div className="text-center text-[12px] cursor-pointer hover:underline"
                        onClick={() => {
                          handleNavigation('/dashboard/settings/organization')
                        }}
                      >{JSON.parse(localStorage.getItem('organization')).org_timezone.S} </div>
                      <div className="flex items-center space-x-2 px-2 ">
                        <div className="w-full ">
                          <TimePicker className="custom-time-picker" disableClock={true} clearIcon={""} onChange={(e) => {
                            setRoute({ ...route, early_time: convertTo12Hour(e) })
                          }} value={convertTo24Hour(route?.early_time)} />

                        </div>

                        <Divider sx={{ color: "dark", width: "10px" }} />

                        <div className="w-full  ">
                          <TimePicker disableClock={true} clearIcon={""} className="custom-time-picker" onChange={(e) => {
                            setRoute({ ...route, late_time: convertTo12Hour(e) })
                          }} value={convertTo24Hour(route?.late_time)} />
                        </div>
                      </div>

                      <div className="flex justify-center space-x-[-10px]">
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            S
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_sunday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_sunday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            M
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_monday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_monday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            T
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_tuesday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_tuesday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            W
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_wednesday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_wednesday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            T
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_thursday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_thursday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            F
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_friday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_friday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-[-15px]">
                          <div className="text-center lg:text-[14px] text-[12px]">
                            S
                          </div>
                          <div>
                            <Checkbox
                              checked={route?.active_saturday}
                              onChange={(e) =>
                                setRoute({
                                  ...route,
                                  active_saturday: e.target.checked,
                                })
                              }
                              size="lg"
                              sx={{
                                color: "#605BFF",
                                "&.Mui-checked": {
                                  color: "#605BFF", // Set color for checked state
                                },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="border-[1px] rounded-[14px] px-2 py-2 w-fit border-[#DADADA] space-y-3 h-[190px] pt-5 relative bottom-2">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Day/Time Rules
                      </div>
                      <div className="text-center text-[12px]">
                        Please upgrade to edit day/time rules</div>

                      <div className=" pt-[50px]">
                        <Button
                          sx={{
                            textTransform: "none",
                            bgcolor: "#605BFF",
                            color: "white",
                            py: "1px",
                            px: "2px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "100%",
                          }}
                          onClick={() => {
                            handleNavigation("/dashboard/settings/billing");
                          }}
                        >
                          Upgrade
                        </Button>
                      </div>
                    </div>
                  )}



                  <img src="/icons/arrow.png" className="w-[90px]" />

                  <div className="border-[1px] rounded-[14px] px-2 py-2 w-[200px]  min-w-[200px] max-w-[200px]  border-[#DADADA] space-y-2 relative bottom-2">
                    <div className="text-center lg:text-[14px] text-[12px]">
                      Primary Action
                    </div>
                    <div>
                      <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={route?.primary_action}
                        onChange={(e) => {
                          setRoute({
                            ...route,
                            primary_action: e.target.value,
                          });
                        }}
                        className="mb-2 bg-[#FAFAFB]"
                        sx={{
                          fontSize: { lg: "14px", xs: "12px" },
                          padding: "4px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-select": {
                            padding: "4px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        <MenuItem value="forwardvwm">Forward w/ VM</MenuItem>
                        <MenuItem value="send_to_vm">Send to Voicemail</MenuItem>
                        <MenuItem value="play_recording">Play Recording</MenuItem>
                        <MenuItem value="forward">Forward</MenuItem>
                      </Select>
                    </div>

                    {(route?.primary_action === "forward" ||
                      route?.primary_action === "forwardvwm") && (
                        <div>
                          <div>
                            <Select
                              IconComponent={KeyboardArrowDown}
                              fullWidth
                              defaultValue="Forward w/ VM"
                              className="mb-2 bg-[#FAFAFB]"
                              value={route?.primary_number}
                              onChange={(e) => {
                                setRoute({
                                  ...route,
                                  primary_number: e.target.value,
                                });
                              }}
                              sx={{
                                fontSize: { lg: "14px", xs: "12px" },
                                padding: "4px 8px", // Adjust padding here
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .MuiSelect-select": {
                                  padding: "4px 8px", // Adjust padding for the text inside Select
                                },
                              }}
                            >
                              {JSON.parse(localStorage.getItem("organization"))
                                .channels?.L.filter(
                                  (e) => e.M.type.S === "forward_number"
                                )
                                .map((item, index) => {
                                  return (
                                    <MenuItem value={item.M.value.S}>
                                      {item.M.value.S}
                                    </MenuItem>
                                  );
                                })}

                              <MenuItem sx={{
                                textAlign: 'center',
                                textTransform: "none",
                                bgcolor: "white",
                                color: "#605BFF",
                                px: "2px",
                                borderRadius: "7px",
                                fontSize: { lg: "14px", xs: "13px" },
                                width: "100%",
                              }}
                                onClick={() => {
                                  handleNavigation("/dashboard/channels?channeltype=forward_number");
                                }}
                              >
                                <div className="text-center w-full"> Add Phone Number</div>
                              </MenuItem>
                            </Select>

                            {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "none",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "2px",
                              borderRadius: "7px",
                              fontSize: { lg: "14px", xs: "13px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation("/dashboard/channels?channeltype=forward_number");
                            }}
                          >
                            Add Number
                          </Button>
                        </div> */}
                          </div>
                        </div>
                      )}
                    {(route?.primary_action === "play_recording" ||
                      route?.primary_action === "send_to_vm" ||
                      route?.primary_action === "forwardvwm") && (
                        <div>
                          <div>
                            <Select
                              IconComponent={KeyboardArrowDown}
                              fullWidth
                              defaultValue="Forward w/ VM"
                              className="mb-2 bg-[#FAFAFB]"
                              value={route?.recording_id}
                              onChange={(e) => {
                                setRoute({
                                  ...route,
                                  recording_id: e.target.value,
                                });
                              }}
                              sx={{
                                fontSize: { lg: "14px", xs: "12px" },
                                padding: "4px 8px", // Adjust padding here
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .MuiSelect-select": {
                                  padding: "4px 8px", // Adjust padding for the text inside Select
                                },
                              }}
                            >
                              {JSON.parse(
                                localStorage.getItem("organization")
                              ).recordings?.L.map((item, index) => {
                                return (
                                  <MenuItem value={item.M.rec_id.S}>
                                    {item.M.title.S}
                                  </MenuItem>
                                );
                              })}

                              <MenuItem sx={{
                                textAlign: 'center',
                                textTransform: "none",
                                bgcolor: "white",
                                color: "#605BFF",
                                px: "2px",
                                borderRadius: "7px",
                                fontSize: { lg: "14px", xs: "13px" },
                                width: "100%",
                              }}
                                onClick={() => {
                                  handleNavigation("/dashboard/recordings");
                                }}
                              >
                                <div className="text-center w-full">   Add Recording</div>
                              </MenuItem>
                            </Select>

                            {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "none",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "2px",
                              borderRadius: "7px",
                              fontSize: { lg: "14px", xs: "13px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation("/dashboard/recordings");
                            }}
                          >
                            Add Recording
                          </Button>
                        </div> */}
                          </div>
                        </div>
                      )}
                    {/* <div>
                 <Select
                   IconComponent={KeyboardArrowDown}
                   fullWidth
                   defaultValue="Forward w/ VM"
                   className="mb-2 bg-[#FAFAFB]"
                   sx={{
                     fontSize: { lg: "14px", xs: "12px" },
                     padding: "4px 8px", // Adjust padding here
                     "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                     "& .MuiSelect-select": {
                       padding: "4px 8px", // Adjust padding for the text inside Select
                     },
                   }}
                 >
                   <MenuItem value="Forward w/ VM">Default Recording</MenuItem>
                   <MenuItem value="Send to VM">Default Recording</MenuItem>
                 </Select>
               </div> */}
                  </div>

                  <img src="/icons/arrow.png" className="w-[90px]" />

                  <div className="  border-[1px] rounded-[14px] px-2 py-2 lg:w-[150px] max-w-[150px] min-w-[150px]  border-[#DADADA] space-y-2 relative bottom-2">
                    <div className="text-center lg:text-[14px] text-[12px]">
                      Notification
                    </div>
                    <div>
                      <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        defaultValue="email"
                        value={notification.notification}
                        onChange={(e) => {
                          setNotification({
                            ...notification,
                            notification: e.target.value,
                          });

                          if (e.target.value === 'none') {
                            setRoute({ ...route, primary_channel: '' });
                          }
                        }}
                        className="mb-2 bg-[#FAFAFB]"
                        sx={{
                          fontSize: { lg: "14px", xs: "12px" },
                          padding: "4px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-select": {
                            padding: "4px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        <MenuItem value="none">None</MenuItem>
                        <MenuItem value="email">Email</MenuItem>
                        <MenuItem value="sms">SMS</MenuItem>
                        <MenuItem value="front">Front</MenuItem>
                        <MenuItem value="slack">Slack</MenuItem>
                      </Select>
                    </div>
                    {notification.notification !== 'none' && (
                      <div>
                        <Select
                          IconComponent={KeyboardArrowDown}
                          fullWidth
                          defaultValue={notification.notification_detail}
                          value={notification.notification_detail}
                          onChange={(e) => {
                            setNotification({
                              ...notification,
                              notification_detail: e.target.value,
                            });

                            let ch_id = JSON.parse(
                              localStorage.getItem("organization")
                            ).channels?.L.filter(
                              (ch) =>
                                ch.M.value.S === e.target.value &&
                                ch.M.type.S === notification.notification
                            )[0]?.M.ch_id.S || '';
                            console.log({ ch_id });
                            setRoute({ ...route, primary_channel: ch_id || '' });
                          }}
                          className="mb-2 bg-[#FAFAFB]"
                          sx={{
                            fontSize: { lg: "14px", xs: "12px" },
                            padding: "4px 8px", // Adjust padding here
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            "& .MuiSelect-select": {
                              padding: "4px 8px", // Adjust padding for the text inside Select
                            },
                          }}
                        >
                          {JSON.parse(localStorage.getItem("organization"))
                            .channels?.L.filter(
                              (e) => e.M.type.S === notification.notification
                            )
                            .map((item, index) => {
                              console.log("item", item);
                              if (notification.notification === 'sms') {
                                return (
                                  <MenuItem value={item.M.value.S}>
                                    {formatPhoneNumber(item.M.value.S)}
                                  </MenuItem>
                                );
                              } else {
                                return (
                                  <MenuItem value={item.M.value.S}>
                                    {item.M.value.S}
                                  </MenuItem>
                                );
                              }
                            })}
                          <MenuItem sx={{
                            textAlign: 'center',
                            textTransform: "none",
                            bgcolor: "white",
                            color: "#605BFF",
                            px: "2px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "100%",
                          }}
                            onClick={() => {
                              handleNavigation(`/dashboard/channels/?channeltype=${notification.notification}`);
                            }}
                          >
                            <div className="text-center w-full capitalize">   Add {notification.notification} channel</div>
                          </MenuItem>

                        </Select>
                        {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "capitalize",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "3px",
                              borderRadius: "7px",
                              fontSize: { lg: "12px", xs: "12px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation(`/dashboard/channels/?channeltype=${notification.notification}`);
                            }}
                          >
                            Add {notification.notification} channel
                          </Button>
                        </div> */}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center  relative lg:left-[370px]  w-fit  left-[370px] lg:bottom-6 bottom-2">
                  <img
                    src="/icons/arrow-bend.png"
                    className="lg:w-[150px] w-[200px] object-cover"
                  />

                  {planDetails?.planName === 'Basic' ? (
                    <div className="border-[1px] rounded-[14px] px-2 py-2 w-[200px] min-w-[200px] max-w-[200px] border-[#DADADA] space-y-3 h-[190px] pt-5 relative lg:top-12 top-14">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Off-Hours Action
                      </div>
                      <div className="text-center text-[12px]">
                        Please upgrade to edit off-hours action</div>

                      <div className=" pt-[40px]">
                        <Button
                          sx={{
                            textTransform: "none",
                            bgcolor: "#605BFF",
                            color: "white",
                            py: "1px",
                            px: "2px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "100%",
                          }}
                          onClick={() => {
                            navigate("/dashboard/settings/billing");
                          }}
                        >
                          Upgrade
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="border-[1px] rounded-[14px] px-5 py-2 w-[200px] min-w-[200px] max-w-[200px] border-[#DADADA] space-y-2 relative lg:top-12 top-14">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Off-Hours Action
                      </div>
                      <div>
                        <Select
                          IconComponent={KeyboardArrowDown}
                          fullWidth
                          value={route?.off_hours_action}
                          onChange={(e) => {
                            setRoute({
                              ...route,
                              off_hours_action: e.target.value,
                            });
                          }}
                          className="mb-2 bg-[#FAFAFB]"
                          sx={{
                            fontSize: { lg: "14px", xs: "12px" },
                            padding: "4px 8px", // Adjust padding here
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            "& .MuiSelect-select": {
                              padding: "4px 8px", // Adjust padding for the text inside Select
                            },
                          }}
                        >
                          <MenuItem value="forwardvwm">Forward w/ VM</MenuItem>
                          <MenuItem value="send_to_vm">Send to Voicemail</MenuItem>
                          <MenuItem value="play_recording">Play Recording</MenuItem>
                          <MenuItem value="forward">Forward</MenuItem>
                        </Select>
                      </div>

                      {(route?.off_hours_action === "forward" ||
                        route?.off_hours_action === "forwardvwm") && (
                          <div>
                            <div>
                              <Select
                                IconComponent={KeyboardArrowDown}
                                fullWidth
                                defaultValue="Forward w/ VM"
                                className="mb-2 bg-[#FAFAFB]"
                                value={route?.off_hours_number}
                                onChange={(e) => {
                                  setRoute({
                                    ...route,
                                    off_hours_number: e.target.value,
                                    off_hours_channel: JSON.parse(
                                      localStorage.getItem("organization")
                                    ).channels?.L.filter(
                                      (f) => f.M.value.S === e.target.value
                                    )[0].M.ch_id.S,
                                  });
                                }}
                                sx={{
                                  fontSize: { lg: "14px", xs: "12px" },
                                  padding: "4px 8px", // Adjust padding here
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "& .MuiSelect-select": {
                                    padding: "4px 8px", // Adjust padding for the text inside Select
                                  },
                                }}
                              >
                                {JSON.parse(localStorage.getItem("organization"))
                                  .channels?.L.filter(
                                    (e) => e.M.type.S === "forward_number"
                                  )
                                  .map((item, index) => {
                                    return (
                                      <MenuItem value={item.M.value.S}>
                                        {formatPhoneNumber(item.M.value.S)}
                                      </MenuItem>
                                    );
                                  })}
                                <MenuItem sx={{
                                  textAlign: 'center',
                                  textTransform: "none",
                                  bgcolor: "white",
                                  color: "#605BFF",
                                  px: "2px",
                                  borderRadius: "7px",
                                  fontSize: { lg: "14px", xs: "13px" },
                                  width: "100%",
                                }}
                                  onClick={() => {
                                    handleNavigation("/dashboard/channels?channeltype=forward_number");
                                  }}
                                >
                                  <div className="text-center w-full"> Add Phone  Number</div>
                                </MenuItem>
                              </Select>

                              {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "none",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "2px",
                              borderRadius: "7px",
                              fontSize: { lg: "14px", xs: "13px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation("/dashboard/channels?channeltype=forward_number");
                            }}
                          >
                            Add Number
                          </Button>
                        </div> */}
                            </div>
                          </div>
                        )}
                      {(route?.off_hours_action === "play_recording" ||
                        route?.off_hours_action === "send_to_vm" ||
                        route?.off_hours_action === "forwardvwm") && (
                          <div>
                            <div>
                              <Select
                                IconComponent={KeyboardArrowDown}
                                fullWidth
                                defaultValue="Forward w/ VM"
                                className="mb-2 bg-[#FAFAFB]"
                                value={route?.off_hours_recording}
                                onChange={(e) => {
                                  setRoute({
                                    ...route,
                                    off_hours_recording: e.target.value,
                                  });
                                }}
                                sx={{
                                  fontSize: { lg: "14px", xs: "12px" },
                                  padding: "4px 8px", // Adjust padding here
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "& .MuiSelect-select": {
                                    padding: "4px 8px", // Adjust padding for the text inside Select
                                  },
                                }}
                              >
                                {JSON.parse(
                                  localStorage.getItem("organization")
                                ).recordings?.L.map((item, index) => {
                                  return (
                                    <MenuItem value={item.M.rec_id.S}>
                                      {item.M.title.S}
                                    </MenuItem>
                                  );
                                })}

                                <MenuItem sx={{
                                  textAlign: 'center',
                                  textTransform: "none",
                                  bgcolor: "white",
                                  color: "#605BFF",
                                  px: "2px",
                                  borderRadius: "7px",
                                  fontSize: { lg: "14px", xs: "13px" },
                                  width: "100%",
                                }}
                                  onClick={() => {
                                    handleNavigation("/dashboard/recordings");
                                  }}
                                >
                                  <div className="text-center w-full">   Add Recording</div>
                                </MenuItem>
                              </Select>

                              {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "none",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "2px",
                              borderRadius: "7px",
                              fontSize: { lg: "14px", xs: "13px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation("/dashboard/recordings");
                            }}
                          >
                            Add Recording
                          </Button>
                        </div> */}
                            </div>
                          </div>
                        )}
                      {/* <div>
                 <Select
                   IconComponent={KeyboardArrowDown}
                   fullWidth
                   defaultValue="Forward w/ VM"
                   className="mb-2 bg-[#FAFAFB]"
                   sx={{
                     fontSize: { lg: "14px", xs: "12px" },
                     padding: "4px 8px", // Adjust padding here
                     "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                     "& .MuiSelect-select": {
                       padding: "4px 8px", // Adjust padding for the text inside Select
                     },
                   }}
                 >
                   <MenuItem value="Forward w/ VM">Default Recording</MenuItem>
                   <MenuItem value="Send to VM">Default Recording</MenuItem>
                 </Select>
               </div> */}
                    </div>
                  )}
                  <img
                    src="/icons/arrow.png"
                    className="w-[90px] relative top-12"
                  />

                  {planDetails?.planName === 'Basic' ? (
                    <div className="border-[1px] rounded-[14px] px-2 py-2 lg:w-[150px] max-w-[150px] min-w-[150px] border-[#DADADA] space-y-3  pt-5 relative top-12">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Notification
                      </div>
                      <div className="text-center text-[12px]">
                        Please upgrade to edit off-hours notification</div>

                      <div className=" pt-[20px]">
                        <Button
                          sx={{
                            textTransform: "none",
                            bgcolor: "#605BFF",
                            color: "white",
                            py: "1px",
                            px: "2px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "100%",
                          }}
                          onClick={() => {
                            handleNavigation("/dashboard/settings/billing");
                          }}
                        >
                          Upgrade
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="border-[1px]  rounded-[14px] px-2 py-2 lg:w-[150px] max-w-[150px] min-w-[150px]  border-[#DADADA] space-y-2 relative top-12">
                      <div className="text-center lg:text-[14px] text-[12px]">
                        Notification
                      </div>
                      <div>
                        <Select
                          IconComponent={KeyboardArrowDown}
                          fullWidth
                          defaultValue="email"
                          value={off_hours_notification.notification}
                          onChange={(e) => {
                            setOffHoursNotification({
                              ...off_hours_notification,
                              notification: e.target.value,
                            });

                            if (e.target.value === 'none') {
                              setRoute({ ...route, off_hours_channel: '' });
                            }
                          }}
                          className="mb-2 bg-[#FAFAFB]"
                          sx={{
                            fontSize: { lg: "14px", xs: "12px" },
                            padding: "4px 8px", // Adjust padding here
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            "& .MuiSelect-select": {
                              padding: "4px 8px", // Adjust padding for the text inside Select
                            },
                          }}
                        >
                          <MenuItem value="none">None</MenuItem>
                          <MenuItem value="email">Email</MenuItem>
                          <MenuItem value="sms">SMS</MenuItem>
                          <MenuItem value="front">Front</MenuItem>
                          <MenuItem value="slack">Slack</MenuItem>
                        </Select>
                      </div>
                      {off_hours_notification.notification !== 'none' && (
                        <div>
                          <Select
                            IconComponent={KeyboardArrowDown}
                            fullWidth
                            defaultValue=""
                            value={off_hours_notification.notification_detail}
                            onChange={(e) => {
                              setOffHoursNotification({
                                ...off_hours_notification,
                                notification_detail: e.target.value,
                              });

                              let ch_id = JSON.parse(
                                localStorage.getItem("organization")
                              ).channels?.L.filter(
                                (ch) =>
                                  ch.M.value.S === e.target.value &&
                                  ch.M.type.S === off_hours_notification.notification
                              )[0]?.M.ch_id.S;
                              console.log({ ch_id });
                              setRoute({
                                ...route,
                                off_hours_channel: ch_id || null,
                              });
                            }}
                            className="mb-2 bg-[#FAFAFB]"
                            sx={{
                              fontSize: { lg: "14px", xs: "12px" },
                              padding: "4px 8px", // Adjust padding here
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .MuiSelect-select": {
                                padding: "4px 8px", // Adjust padding for the text inside Select
                              },
                            }}
                          >
                            {JSON.parse(localStorage.getItem("organization"))
                              .channels?.L.filter(
                                (e) =>
                                  e.M.type.S === off_hours_notification.notification
                              )
                              .map((item, index) => {
                                console.log("item", item);
                                if (off_hours_notification === 'sms') {
                                  return (
                                    <MenuItem value={item.M.value.S}>
                                      {formatPhoneNumber(item.M.value.S)}
                                    </MenuItem>
                                  );
                                } else {
                                  return (
                                    <MenuItem value={item.M.value.S}>
                                      {item.M.value.S}
                                    </MenuItem>
                                  );
                                }
                              })}
                            <MenuItem sx={{
                              textAlign: 'center',
                              textTransform: "none",
                              bgcolor: "white",
                              color: "#605BFF",
                              px: "2px",
                              borderRadius: "7px",
                              fontSize: { lg: "14px", xs: "13px" },
                              width: "100%",
                            }}
                              onClick={() => {
                                handleNavigation(`/dashboard/channels/?channeltype=${off_hours_notification.notification}`);
                              }}
                            >
                              <div className="text-center w-full capitalize">   Add {off_hours_notification.notification} channel</div>
                            </MenuItem>
                          </Select>

                          {/* <div className="mt-2">
                          <Button
                            sx={{
                              textTransform: "capitalize",
                              bgcolor: "#605BFF",
                              color: "white",
                              py: "1px",
                              px: "3px",
                              borderRadius: "7px",
                              fontSize: { lg: "12px", xs: "12px" },
                              width: "100%",
                            }}
                            onClick={() => {
                              handleNavigation(`/dashboard/channels/?channeltype=${off_hours_notification.notification}`);
                            }}
                          >
                            Add {off_hours_notification.notification} channel
                          </Button>
                        </div> */}
                        </div>
                      )}
                    </div>
                  )}


                </div>

                <div className="lg:flex justify-end pt-8 block  ">
                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "#605BFF",
                      color: "white",
                      py: "10px",
                      px: "9px",
                      borderRadius: "12px",
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                    disabled={loader}
                    onClick={() => {
                      if (route_id) {
                        updateRoute();
                      } else {
                        createRoute();
                      }
                    }}
                  >
                    {route_id ? "Save Changes" : "Add Route"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="">
            <div className="lg:px-8 px-4 py-14 bg-white  w-fit">
              {/* <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Alert !!</div> */}


              <div className="lg:text-[14px] text-[13px] text-center mb-2" >
                Oops! We couldn't find a record for {route_id ? 'route' : 'call'} <span className="font-bold"> {route_id}</span> in <span className="font-bold">{JSON.parse(localStorage.getItem('organization'))?.organization_name?.S}</span>.
                Is it possible the URL is incorrect or that you mean to be logged in as a different organization?
                If you need help, please <a className="text-blue-800 hover:underline" href='mailto:hello@twilanswer.com'>Contact Support</a>.


              </div>

              {/* <div>
              <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={
                          user?.relatedOrgs.L.filter(
                            (e) =>
                              e?.M.org_id.S ===
                              JSON.parse(localStorage.getItem("organization")).orgId.S
                          )[0]?.M.org_id.S
                        }
                        onChange={(f) => {
                          changeOrganization(f.target.value);
                        }}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {user?.relatedOrgs.L.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.M.org_id.S}>{orgs?.find((e)=> e.orgId.S === item.M.org_id.S)?.organization_name.S}</MenuItem>
                          );
                        })}
                      </Select>
        </div> */}


              <div className="flex items-center justify-center space-x-3 mt-4">

                <div className="flex items-center justify-center space-x-3 mt-4">
                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "rgba(236,72,92,0.1)",
                      color: "rgba(236,72,92,1)",
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",

                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={() => {

                      localStorage.clear()
                      navigate('/login')
                    }}
                  >
                    Logout
                  </Button>

                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "#605BFF",
                      color: "white",
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",

                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={() => {

                      {
                        route_id ? (
                          navigate('/dashboard/call-routings')
                        ) : (
                          navigate('/dashboard/')
                        )
                      }
                    }}
                  >
                    Go to {route_id ? 'routes' : 'dashboard'}
                  </Button>

                </div>


              </div>



            </div>
          </div>
        )
        }
      </div>
    </>
  );
};

export default CallRoute;
